/// <reference path="../../../../typings.d.ts" />

import * as parser from 'parse-address';

export function parseAddress(
  address: string,
  addressKey = 'line_1',
  line2KeyWithoutUnderscore = false
) {
  const parsed = parser.parseLocation(address);
  const result: any = {};
  const line2Key = line2KeyWithoutUnderscore ? 'line2' : 'line_2';
  if (parsed) {
    result[addressKey] = `
          ${parsed.number || ''}
          ${parsed.prefix || ''}
          ${parsed.street || ''}
          ${parsed.type || ''}
          `
      .replace(/\s+/g, ' ')
      .trim();
    result[line2Key] = '';
    if (parsed.sec_unit_type && parsed.sec_unit_num) {
      result[line2Key] = `${parsed.sec_unit_type} ${parsed.sec_unit_num}`;
    }
    result.city = parsed.city;
    result.state = parsed.state;
    result.zipcode = parsed.zip;
  }
  return result;
}

interface BasicAddress {
  address: string;
  city: string;
  state: string;
  zipcode: string;
  line_2?: string;
  line2?: string; // allows either line2 OR line_2, and both are optional
  [key: string]: any; // allows unexpected foreign keys incase consumers have extra keys that are not included in our BasicAddress interface
}

export function constructAddressObjToString(addressObj: BasicAddress, line2Key = 'line_2'): string {
  let str = `${addressObj.address}`;
  if (addressObj[line2Key]) {
    str += ` ${addressObj[line2Key]}`;
  }
  str += `, ${addressObj.city}, ${addressObj.state} ${addressObj.zipcode}`;
  return str;
}
